module.exports = __webpack_public_path__ + "685a75752216062fa9e862f1e62c1aa1.png";


/*****************
 ** WEBPACK FOOTER
 ** ./~/file-loader!./src/app/images/Velox_Logo_Login.png
 ** module id = 453
 ** module chunks = 0
 **/